module.exports = __webpack_public_path__ + "img/CHEVRON_TOP.607cfe09.svg";